import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-workshop',
  templateUrl: './workshop.component.html',
  styleUrls: ['./workshop.component.css']
})
export class WorkshopComponent implements OnInit {
  displayStyles = "none";
  constructor() { }

  ngOnInit(){
    this.displayStyles = "block";
    window.location.href = 'https://real-reindeer.webinarninja.com/live-webinars/10448257/register'
  }

}
